import { useLocation } from "wouter";
import { MarketplaceHeader } from '@/components/marketplace/marketplace-header';
import { DeckMarketplaceContent } from '@/components/marketplace/deck-marketplace-content';
import { PullToRefresh } from '@/components/ui/pull-to-refresh';
import { useQueryClient } from '@tanstack/react-query';

export default function DeckMarketplace() {
  const [_, setLocation] = useLocation();
  const queryClient = useQueryClient();

  // Handle pull-to-refresh
  const handleRefresh = async () => {
    // Invalidate relevant queries for marketplace decks
    await queryClient.invalidateQueries({ queryKey: ["deck"] });
    return Promise.resolve();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-950 via-gray-900 to-black text-white pb-20">
      <MarketplaceHeader title="Deck Marketplace" backPath="/shop?tab=marketplace" />
      <PullToRefresh 
        onRefresh={handleRefresh}
        refreshTheme="primary"
        showToastOnRefresh={true}
        toastMessage="Marketplace refreshed"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <DeckMarketplaceContent
            showFeaturedDeck={true}
            onSelectDeck={(deckId) => setLocation(`/deck/${deckId}?returnTo=marketplace`)}
          />
        </div>
      </PullToRefresh>
    </div>
  );
}
